import CONFIG from 'Config/settings';

export default class LoqateAutofill {
  constructor() {
    this.apiUrl = CONFIG.API.ADDRESS_AUTOCOMPLETE.HOST;
    this.apiKey = CONFIG.API.ADDRESS_AUTOCOMPLETE.CLIENT_ID;
    this.countryCode = CONFIG.COUNTRY;
    this.languageCode = CONFIG.LANGUAGE;
  }

  async filter(searchData, successCallback, failureCallback) {
    const requestBody = {
      country: this.countryCode,
      language: this.languageCode,
      freeText: searchData.zipCode
    };
    const result = await fetch(this.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-client-id': `${this.apiKey}`
      },
      body: JSON.stringify(requestBody)
    });

    if (!result.ok) {
      failureCallback();
      return;
    }
    const { addressLine1, city, postalCode, state } = await result.json();

    if (!addressLine1 && !city && !postalCode && !state) {
      failureCallback();
      return;
    }

    successCallback({
      address1: addressLine1,
      cityName: city || '',
      zipCode: postalCode || '',
      province: state || '',
      address2: ''
    });
  }
}
